<template>
  <v-app>
    <router-view />
    <SessionOut :sessionOut="sessionOut" @closeSession="sessionOut = false" />
    <v-snackbar
      v-model="alert.show"
      top
      rounded="pill"
      centered
      :color="alert.color"
      dense
    >
      <v-alert :type="alert.color" class="mb-0 ma-0 pa-0" dense>{{
        alert.message
      }}</v-alert>
      <template v-slot:action="{ attrs }">
        <v-btn depressed icon v-bind="attrs" @click="alert.show = !alert.show">
          <v-icon>mdi-close-circle-outline</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </v-app>
</template>

<script>
import SessionOut from "@/utils/SessionOut.vue";
import { mapState } from "vuex";
export default {
  name: "AppView",
  data: () => {
    return {};
  },
  computed: {
    ...mapState(["alert", "sessionOut"]),
  },
  components: {
    SessionOut,
  },
};
</script>
<style scoped>
.rounded {
  border-radius: 10px !important;
}
</style>
